// extracted by mini-css-extract-plugin
export default {"checkbox":"styles_checkbox__KO+TD","indicator":"styles_indicator__eoNbX","checkboxLabel":"styles_checkboxLabel__rbEN0","disabled":"styles_disabled__zM4RY"};